import { useMemo } from "react";
import { ClipDropdown, type ClipDropdownOption } from "@components/ClipDropdown/ClipDropdown";
import { AccountIdentity } from "@components/AccountIdentity/AccountIdentity";
import type { LinkedAccount } from "@store/linkedAccountSlice";
import { TestId } from "@shared/testIds";
import { twMerge } from "tailwind-merge";

export interface AccountSelectorProps {
  accounts: LinkedAccount[];
  value: number;
  onChange: (linkId: number) => void;
  disabled?: boolean;
}

export const AccountSelector = ({ accounts, value, onChange, disabled }: AccountSelectorProps) => {
  const selectedAccount = accounts.find((account) => account.id === value) ?? accounts[0];

  const options: ClipDropdownOption[] = useMemo(
    () =>
      accounts
        .filter((account) => account.id !== undefined)
        .map((account) => ({
          key: String(account.id),
          label: <AccountIdentity account={account} />,
        })),
    [accounts],
  );

  const triggerTitle = selectedAccount ? <AccountIdentity account={selectedAccount} /> : null;

  return (
    <div data-testid={TestId.PostToTikTokAccountSelect}>
      <ClipDropdown
        value={String(value)}
        onChange={(key) => onChange(Number(key))}
        options={options}
        title={triggerTitle}
        disabled={disabled}
        trigger={["click"]}
        placement="bottomLeft"
        overlayClassName="w-[320px]"
        className={twMerge(
          "box-border h-[32px] w-[320px] justify-between gap-[6px] rounded-[8px] border border-kds-border-solid bg-kds-bg-element px-[8px] py-[4px]",
          "text-[14px] font-normal leading-[20px] shadow-none hover:bg-kds-bg-element",
        )}
        getPopupContainer={(triggerNode) => triggerNode.parentElement ?? document.body}
      />
    </div>
  );
};
